import { render, staticRenderFns } from "./CustomAttributesListItem.vue?vue&type=template&id=8b8bc9f8"
import script from "./CustomAttributesListItem.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesListItem.vue?vue&type=script&lang=ts"
import style0 from "./CustomAttributesListItem.vue?vue&type=style&index=0&id=8b8bc9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports